import { useState } from 'react';
import { useSearch } from 'src/graphql/entities/search/use-search';
import { ConditionInput, EntityNames } from 'src/graphql/types';

type MergeTargetEntity = EntityNames.Conversation | EntityNames.Site | EntityNames.Client;

/** The search a `MergeTargetPicker` reads: the caller narrows it with tenant and origin conditions. */
export const useMergeTargetSearch = <T extends MergeTargetEntity>({
  entityName,
  conditions,
  targetIdAttributes,
}: {
  entityName: T;
  conditions: ConditionInput[];
  targetIdAttributes?: string[];
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const search = useSearch({ entityName, searchTerm, filter: conditions, targetIdAttributes });

  return {
    records: search?.records ?? [],
    loading: search?.isLoading ?? false,
    hasMore: search?.hasMore ?? false,
    loadMore: search?.loadMore,
    setSearchTerm,
  };
};
